import { useRef } from 'react';

import { isServerSide } from '@/helpers/isServerSide';
import addToSearchParams from '@/helpers/url/addToSearchParams';
import { type TUrlParams } from '@/infra/types/common';
import { type AppStore, type RootState, setupStore } from '@/store';
import buildInitialState from '@/store/buildInitialState';
import { type TFetchableResult } from '@/store/fetchableParts/types';
import chooseRelevant from '@/store/prefill/chooseRelevant';

const useSetupStore = (fetched?: TFetchableResult, urlParams?: TUrlParams) => {
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) {
    let initialState;
    if (fetched) {
      const { relevant, versions } = chooseRelevant(fetched) ?? {};
      const searchParams = urlParams ? addToSearchParams(new URLSearchParams(), urlParams) : new URLSearchParams();
      initialState = { ...buildInitialState(relevant!, searchParams), prefillInfo: versions! } as RootState;
    }
    // On client side - create the store only once, never recreate it.
    // On server side - recreate the store with each request, since rootStore is a global variable and is shared between all clients and all connections.
    storeRef.current = setupStore(initialState, { reconfigure: isServerSide() });
  }
  return storeRef.current;
};

export default useSetupStore;
